import React, { useState, useEffect, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "../../components/LeadDataReport/LeadDataReport.css";
import axios from "axios";
import ExcelExport from "../ExcelExport/ExcelExport";
import Loader from "../../components/Loader/loader";
import filterIcon from "../../Icons/filterIcon.png";
import CryptoJS from "crypto-js";
import search from "../../images/Search.png";
import Forward from "../../images/Group 716.svg";
import arrow from "../../images/arrow.svg";
import JSZip from "jszip";
import showDoc from "../../images/showDoc.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PaymentList = () => {
  const [searchDiv, setsearchDiv] = useState(false);
  const [showFilterDiv, setShowFilterDiv] = useState(false);
  const [loading, setLoading] = useState(false);
  //   const [leadResponse, setLeadResponse] = useState([]);
  const [paymentReceiptResponse, setpaymentReceiptResponse] = useState([]);
  const [paymentData, setPaymentData] = useState([]);
  const [inputDataValue, setInputDataValue] = useState("");
  const [activeReceiptId, setActiveReceiptId] = useState(null);
  const [transactionType, setTransactionType] = useState("");
  const [coordinatorData, setCoordinatorData] = useState("");
  const [assignToResponse, setAssignToResponse] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [dateRange, setDateRange] = useState("Custom Dates");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [statusData, setStatusData] = useState("");
  const fileInputRef = useRef(null);

  const isAdmin = localStorage.getItem("isAdmin");

  const itemsPerPage = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const visibleData = paymentReceiptResponse?.slice(startIndex, endIndex);

  const [firstItem, setFirstItem] = useState({
    relocation_id: "",
    payment_receipt_id: "",
    Quotation: "",
    Amount_In_AED: "",
    Payment_Ter: "",
    Token_Payment: "",
    Remaining_Payment: "",
    Pymt_Status: "",

    payment_mode: "",
    amount: "",
    date_of_payment: "",
    document_path: "",
    UTR_Number: "",
    uploaded_doc_name: "",
  });

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  useEffect(() => {
    tokenStorage();
    getEmployeeByDepartment();
  }, []);

  function tokenStorage() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetPaymentConfirmationReceipt?is_verified=0&startDate=0&endDate=0&searchParam=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setpaymentReceiptResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getEmployeeByDepartment() {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    axios
      .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
        headers: { Authorization: `Bearer ${storedToken}` },
      })
      .then((response) => {
        setAssignToResponse(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
      });
  }

  function getPaymentDataButton() {
    setLoading(true);
    const storedToken = JSON.parse(localStorage.getItem("token"));
    let startdate = formatDate(selectionRange.startDate);
    let enddate = formatDate(selectionRange.endDate);
    if (dateRange === "Custom Dates") {
      startdate = "";
      enddate = "";
    }
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetPaymentConfirmationReceipt?is_verified=${statusData}&startDate=${startdate}&enddate=${enddate}&searchParam=${inputDataValue}&transaction_type=${transactionType}&coordinator=${coordinatorData}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          if (response) {
            setpaymentReceiptResponse(response.data.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        })
        .finally(() => {
          setLoading(false); // Set loading to false when data is fetched
        });
    }
    // setShowFilterDiv(!showFilterDiv);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  function formatDate1(dateString) {
    const date = new Date(dateString);

    // Get weekday, short month, day, and year
    const datePart = new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);

    // Format time (12-hour format)
    const timePart = new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);

    return `${datePart} | ${timePart}`;
  }

  function toggleFilterDiv() {
    setShowFilterDiv(!showFilterDiv);
    if (activeReceiptId) {
      setActiveReceiptId(!activeReceiptId);
    }
  }

  function toggleSearchDiv(payment_receipt_id) {
    if (showFilterDiv) {
      setShowFilterDiv(!showFilterDiv);
    }
    if (activeReceiptId === payment_receipt_id) return; // Prevent re-fetching if the same row is clicked

    setActiveReceiptId(payment_receipt_id);

    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetPaymentConfirmation?payment_receipt_id=${payment_receipt_id}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )

        .then((response) => {
          setPaymentData(response.data.data);
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const closeSearchDiv = () => {
    setActiveReceiptId(null);
  };

  function getPaymentColor(Pymt_Status) {
    switch (Pymt_Status) {
      case "Partial":
        return "yellow";
      case "Received":
        return "#28A745";
      case "Pending":
        return "orange";
      default:
        return "white";
    }
  }

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const updateData = async (payment_receipt_id, e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("payment_receipt_id", payment_receipt_id);
    formData.append("relocation_id", firstItem.relocation_id);
    formData.append("amount", firstItem.amount);
    formData.append("date_of_payment", firstItem.date_of_payment);
    formData.append("is_verified", firstItem.is_verified);
    formData.append("UTR_Number", firstItem.UTR_Number);

    // Ensure the file itself is being sent
    formData.append("uploaded_doc_name", firstItem.uploaded_doc_name);

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));

      const response = await axios.post(
        `${baseAPI}userpost/UpdatePaymentReceiptsInfo`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "multipart/form-data", // Ensure you're sending form data
          },
        }
      );
      tokenStorage();
      console.log("hello");
      // window.location.reload();
      toast.success("Data Saved Successfully!!", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log("toast.success", toast.success);
      console.log("hello1");
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const togglePicker = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const handleApplyFilter = () => {
    setDateRange(
      formatDate(selectionRange.startDate) +
      " - " +
      formatDate(selectionRange.endDate)
    );
    setIsOpen(false);
    // You can perform additional actions here based on the selected attribute and date range
  };

  const handleTransactionType = (event) => {
    setTransactionType(event.target.value);
  };

  const handleCoordinatorChange = (event) => {
    setCoordinatorData(event.target.value);
  };

  const handleClearFilter = () => {
    setDateRange("");
    setIsOpen(false);
    setSelectionRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    });
  };

  const handleStatus = (event) => {
    setStatusData(event.target.value);
  };

  const handleSearchParamChange = (event) => {
    setInputDataValue(event.target.value);
  };

  const renderDateRangePicker = () => {
    return (
      isOpen && (
        <div
          style={{
            position: "absolute",
            zIndex: 999,
            border: "solid 1px black",
            marginLeft: "1rem",
            width: "35pc",
            background: "white",
          }}
        >
          <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
          <button
            onClick={handleApplyFilter}
            style={{
              marginBottom: "1rem",
              width: "8rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              position: "relative",
              top: "1px",
              left: "19pc",
              backgroundColor: "#5B489D",
              color: "White",
              border: "none",
            }}
          >
            Apply Filter
          </button>
          <button
            onClick={handleClearFilter}
            style={{
              marginBottom: "1rem",
              width: "7.5rem",
              height: "2.5rem",
              borderRadius: "0.5rem",
              fontSize: "13px",
              position: "relative",
              top: "1px",
              left: "19pc",
              color: "red",
              backgroundColor: "white",
              border: "none",
              fontWeight: "bold",
            }}
          >
            Clear Filter
          </button>
        </div>
      )
    );
  };

  const resetForm = () => {
    setDateRange("");
    setStatusData("");
    setInputDataValue("");
    setTransactionType("");
    setCoordinatorData("");
    setSelectionRange({
      startDate: "",
      endDate: "",
      key: "selection",
    });
  };

  function handleChangeDoc(e) {
    const { name, value, files } = e.target;

    if (name === "uploaded_doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        if (
          file.type === "application/zip" ||
          file.type === "application/x-zip-compressed"
        ) {
          validateZipFile(file, name, e);
        } else {
          getUpdatedImage(file, name);
        }
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
      "application/zip", // ZIP
      "application/x-zip-compressed", // Alternate ZIP MIME type
    ];
    return file && allowedTypes.includes(file.type);
  }

  function validateZipFile(file, name, e) {
    const reader = new FileReader();
    reader.onload = function (event) {
      const zipData = event.target.result;

      // Perform ZIP content validation here
      // This might include extracting the files, verifying file types, etc.
      // Client-side libraries like JSZip can help inspect ZIP files
      try {
        const jszip = new JSZip();
        jszip.loadAsync(zipData).then((zip) => {
          const allowedExtensions = ["jpg", "png", "pdf", "docx", "xlsx"];
          let isValid = true;

          zip.forEach((relativePath, zipEntry) => {
            const extension = relativePath.split(".").pop().toLowerCase();
            if (!allowedExtensions.includes(extension)) {
              isValid = false;
            }
          });

          if (isValid) {
            getUpdatedImage(file, name);
          } else {
            alert("ZIP file contains unsupported file types.");
            e.target.value = null;
          }
        });
      } catch (error) {
        alert("Error reading ZIP file.");
        e.target.value = null;
      }
    };

    reader.readAsArrayBuffer(file);
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  function nextPage1(payment_receipt_id) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(payment_receipt_id, key);
    const url = `/PaymentReceiptInfo?payment_receipt_id=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  const transactionTypeStyles = {
    1: {
      label: "Payment Received",
      bg: "#E8F7EF",
      text: "#1E8E5A",
      border: "#1E8E5A"
    },
    2: {
      label: "Partial Refund",
      bg: "#FFF4E5",
      text: "#E67E22",
      border: "#E67E22"
    },
    3: {
      label: "Full Refund",
      bg: "#FDECEA",
      text: "#D93025",
      border: "#D93025"
    },
    4: {
      label: "Refund with Cancellation Charges",
      bg: "#F3E8FF",
      text: "#7B3FE4",
      border: "#7B3FE4"
    }
  }

  const getTransactionStyle = (transactionTypeId) => {
    return (
      transactionTypeStyles[transactionTypeId] || {
        bg: "#F5F5F5",
        text: "#333",
        border: "#ccc"
      }
    );
  };

  function exportToExcel() {
    const exportData = paymentReceiptResponse.map((item, index) => ({
      "Sr. No": index + 1,
      "Lead ID": item.relocation_id,
      "Upload Date and Time": formatDate1(item.created_date),
      "Date of Payment": formatDate1(item.date_of_payment),
      "Transaction Type": item.transaction_type_name,
      "Payment Mode": item.payment_mode,
      "Amount": item.UpdatedAmount !== null ? item.UpdatedAmount : item.amount,      
      "Status": item.is_verified === 0 ? "Requested" : "Verified",
      "Approved By": item.approved_by,
      "Remark": item.remark_Doc,
      "Sales Coordinator": item.Name,
      "Ops Coordinator": item.assigned_coordinator,
      "UTR Number": item.UTR_Number,
    }));

    const headers = Object.keys(exportData[0]);
    const csvRows = [
      headers.join(","),
      ...exportData.map((row) =>
        headers.map((h) => `"${row[h] ?? ""}"`).join(",")
      ),
    ];

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `PaymentList_${new Date().toLocaleDateString()}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }




  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button className="filterButton" onClick={toggleFilterDiv}>
          <img src={filterIcon} /> FILTER
        </button>
        <div style={{ display: "flex" }}>
          <button
            onClick={exportToExcel}
            disabled={!paymentReceiptResponse || paymentReceiptResponse.length === 0}
            style={{
              height: "38px",
              padding: "0 16px",
              backgroundColor: paymentReceiptResponse?.length > 0 ? "#1D6F42" : "#ccc",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: paymentReceiptResponse?.length > 0 ? "pointer" : "not-allowed",
              fontWeight: "bold",
              fontSize: "13px",
            }}
          >
            ⬇ Export to Excel
          </button>
        </div>
      </div>

      {showFilterDiv && (
        <form onSubmit={handleSubmit} className="formContainer">
          <div
            className="container wholeDivContainer"
            style={{ padding: "0px" }}
          >
            <div className="row">
              <div className="col fixArrow">
                {/* <div style={{ paddingRight: "6px" }}> */}
                <button
                  className="form-control optionSize dateRangeButton"
                  style={{
                    // marginBottom: "1rem",
                    height: "2.5rem",
                    borderRadius: "0.4rem",
                    fontSize: "14px",
                    textAlign: "left",
                  }}
                  onClick={togglePicker}
                >
                  {dateRange || "Custom Dates"}
                </button>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
                {renderDateRangePicker()}
                {/* </div> */}
              </div>
              <div className="col fixArrow">
                <select
                  id="statusData"
                  name="statusData"
                  value={statusData}
                  onChange={handleStatus}
                  className="form-control optionSize"
                  placeholder="status"
                >
                  <option value="">Status</option>
                  <option value="0">Requested</option>
                  <option value="1">Verified</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
              <div className="col fixArrow">
                <input
                  id="inputDataValue"
                  name="inputDataValue"
                  value={inputDataValue}
                  onChange={handleSearchParamChange}
                  className="form-control optionSize"
                  placeholder="Enter Lead ID"
                />
              </div>
              <div className="col fixArrow">
                <select
                  id="transactionType"
                  name="transactionType"
                  value={transactionType}
                  onChange={handleTransactionType}
                  className="form-control optionSize"
                >
                  <option value="">Transaction Type</option>
                  <option value="1">Payment Received</option>
                  <option value="2">Partial Refund</option>
                  <option value="3">Full Refund</option>
                  <option value="4">Refund with Cancellation Charges</option>
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>

              <div className="col fixArrow">
                <select
                  id="coordinatorData"
                  name="coordinatorData"
                  value={coordinatorData}
                  onChange={handleCoordinatorChange}
                  className="form-control optionSize"
                >
                  <option value="">Coordinator</option>
                  {assignToResponse.map((emp) => (
                    <option key={emp.email} value={emp.email}>
                      {emp.name}
                    </option>
                  ))}
                </select>
                <span
                  className="arrow"
                  style={{
                    position: "relative",
                    marginLeft: "-32px",
                    marginTop: "14px",
                    color: "#BFBFBF",
                  }}
                >
                  &#9660;
                </span>
              </div>
            </div>

            <hr></hr>
            <div className="row">
              <div className="ApplyClearButton">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={resetForm}
                  style={{
                    marginTop: "12px",
                    border: "none",
                    color: "red",
                    backgroundColor: "white",
                    height: "47px",
                    width: "8rem",
                    fontWeight: "bold",
                  }}
                >
                  Clear Filter
                </button>
                <button
                  type="button"
                  className="btn btn-primary applyButtonFilter"
                  onClick={getPaymentDataButton}
                  style={{
                    marginTop: "12px",
                    marginLeft: "13px",
                    paddingTop: "1px",
                    height: "47px",
                    width: "8rem",
                  }}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </form>
      )}

      <br></br>
      <div className="headingLeadReport">
        <p>Payment List</p>
      </div>

      {activeReceiptId && paymentData !== null
        ? paymentData.map((item, index) => (
          <form
            // onSubmit={handleSubmit}
            className="formContainer"
            style={{ marginBottom: "13px" }}
          >
            <div className="container" style={{ padding: "0px" }}>
              <div className="row" style={{ padding: "2px 13px 0px 13px", display: "flex", justifyContent: "space-between" }}>
                <div className="col-md-6">
                  <span style={{ padding: "3px" }}>Payment Details</span>
                </div>
                <div className="col-md-6 text-end">
                  <span style={{ backgroundColor: "#5b489d", padding: "3px", color: "white", fontWeight: "600" }}>
                    Lead ID : {item.relocation_id}</span>
                </div>
                <hr />
              </div>
              <div style={{ padding: "14px" }}>
                <table
                  style={{
                    width: "100%",
                    color: "#6A6A6A",
                    borderRadius: "5px",
                    border: "1px solid #CCCCCC",
                  }}
                >
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Quotation Amount</span>
                    </th>
                    <td>
                      <span>{item.Quotation}</span>
                    </td>
                    <th>
                      <span>Quotation Amount (AED)</span>
                    </th>
                    <td>
                      <span>{item.Amount_In_AED}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Customer Name</span>
                    </th>
                    <td>
                      <span>
                        {item.First_Name}
                        {item.Last_Name}
                      </span>
                    </td>
                    <th>
                      <span>Lead Owner</span>
                    </th>
                    <td>
                      <span>{item.Lead_Owner}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Uploaded By</span>
                    </th>
                    <td>
                      <span>{item.Uploaded_By}</span>
                    </td>
                    <th>
                      <span>Upload Date & Time</span>
                    </th>
                    <td>
                      <span>{item.created_date}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Token Payment</span>
                    </th>
                    <td>
                      <span>{item.Token_Payment}</span>
                    </td>
                    <th>
                      <span>Remaining Payment</span>
                    </th>
                    <td>
                      <span>{item.Remaining_Payment}</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Payment Status</span>
                    </th>
                    <td>
                      <span
                        style={{
                          padding: "6px",
                          color: "white",
                          fontWeight: "bold",
                          textAlign: "center",
                          backgroundColor: getPaymentColor(
                            firstItem.Pymt_Status
                          ),
                        }}
                      >
                        {item.Pymt_Status}
                      </span>
                    </td>
                    <th>
                      <span>Payment (%)</span>
                    </th>
                    <td>
                      <span>{item.Payment_Ter} %</span>
                    </td>
                  </tr>

                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>UTR Number</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        name="UTR_Number"
                        value={firstItem.UTR_Number}
                        onChange={handleChange1}
                      />
                    </td>
                    <th>
                      <span>Payment Mode</span>
                    </th>
                    <td>
                      <span>{item.payment_mode}</span>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Document</span>
                    </th>
                    <td>
                      {item.doc_name && (
                        <span>
                          <a
                            style={{
                              color: "#6a6a6a",
                              textDecoration: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                            target="_blank"
                            href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                            rel="noopener noreferrer"
                          >
                            Payment Receipt
                          </a>
                        </span>
                      )}
                    </td>
                    <th>
                      <span>Amount</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="text"
                        name="amount"
                        value={firstItem.amount}
                        onChange={handleChange1}
                      />
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Date of Payment Received</span>
                    </th>
                    <td>
                      <input
                        className="form-control"
                        type="date"
                        name="date_of_payment"
                        value={
                          firstItem.date_of_payment
                            ? new Date(
                              firstItem.date_of_payment
                            ).toLocaleDateString("en-CA")
                            : ""
                        }
                        placeholder="Please Enter*"
                        onChange={handleChange1}
                      />
                    </td>
                    <th>
                      <span>Payment Confirmation</span>
                    </th>
                    <td>
                      <select
                        className="form-control"
                        name="is_verified"
                        value={firstItem.is_verified}
                        onChange={handleChange1}
                        disabled={
                          firstItem.UTR_Number !== null &&
                          firstItem.is_verified === 1
                        }
                      >
                        <option
                          className="form-control"
                          value=""
                          placeholder="Please Select*"
                        >
                          Please Select*
                        </option>
                        <option value="0">Not verified</option>
                        <option value="1">Verified</option>
                      </select>
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Upload Payment Receipt</span>
                    </th>
                    <td>
                      <input
                        id="uploaded_doc_name"
                        type="file"
                        name="uploaded_doc_name"
                        onChange={handleChangeDoc}
                        ref={fileInputRef}
                        className="form-control"
                      // style={{ width: "-webkit-fill-available" }}
                      />
                    </td>
                    <th>
                      <span>Uploaded Document</span>
                    </th>
                    <td>
                      {item.uploaded_doc_name && (
                        <span>
                          <a
                            style={{
                              color: "#6a6a6a",
                              textDecoration: "none",
                              cursor: "pointer",
                              fontWeight: "bold",
                            }}
                            target="_blank"
                            href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.uploaded_doc_name}`}
                            rel="noopener noreferrer"
                          >
                            Payment Receipt
                          </a>
                        </span>
                      )}
                    </td>
                  </tr>
                  <tr className="viewLeadDetailsHeading">
                    <th>
                      <span>Transaction Type</span>
                    </th>
                    <td>
                      {(() => {
                        const style = getTransactionStyle(item.transaction_type);
                        return (
                          <span
                            style={{
                              padding: "4px 10px",
                              backgroundColor: style.bg,
                              color: style.text,
                              border: `1px solid ${style.border}`,
                              borderRadius: "5px",
                              fontSize: "13px",
                              fontWeight: "600",
                              whiteSpace: "nowrap"
                            }}
                          >
                            {item.transaction_type_name}
                          </span>
                        );
                      })()}
                    </td>
                    <th>  </th><td></td>
                  </tr>
                </table>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <button
                    style={{
                      marginLeft: "13px",
                      borderRadius: "8px",
                      height: "39px",
                    }}
                  >
                    View More <img src={arrow} alt="arrow" />
                  </button>
                </div>
                <div
                  className="ApplyClearButton"
                  style={{ paddingRight: "27px" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary applyButtonFilter"
                    onClick={(e) => {
                      updateData(item.payment_receipt_id, e);
                      closeSearchDiv(); // Close after update
                    }}
                    style={{
                      marginTop: "12px",
                      marginLeft: "13px",
                      paddingTop: "1px",
                      height: "47px",
                      width: "8rem",
                    }}
                  >
                    Update
                    <ToastContainer />
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={closeSearchDiv}
                    style={{
                      marginTop: "12px",
                      border: "none",
                      color: "red",
                      backgroundColor: "white",
                      height: "47px",
                      width: "8rem",
                      fontWeight: "bold",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        ))
        : null}

      <div
        className="container-fluid"
        style={{ width: "100%", overflowX: "auto", marginLeft: "-9px" }}
      >
        <div className="petBreedList">
          <table>
            <thead>
              <tr
                className="petBreedListHeading"
                style={{
                  whiteSpace: "nowrap",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <th>Sr. No</th>
                <th>Lead ID</th>
                <th>Upload Date and Time</th>
                <th>Date of Payment</th>
                <th>Transaction Type</th>
                <th>Payment Mode</th>
                <th>Amount</th>                
                <th>Status</th>
                <th>Approved By</th>
                <th>Remark</th>
                <th>UTR Number</th>
                <th>Sales Coordinator</th>
                <th>Ops Coordinator</th>
                <th>Action</th>
              </tr>
            </thead>
            {loading ? (
              <div style={{ position: "relative", left: "540px" }}>
                <Loader />
              </div>
            ) : (
              <tbody>
                {visibleData !== null ? (
                  visibleData.map((item, index) => (
                    <tr style={{ backgroundColor: getTransactionStyle(item.transaction_type).bg, color: getTransactionStyle(item.transaction_type).text, }} key={item.payment_receipt_id}>
                      <td>{++index}</td>
                      <td>{item.relocation_id}</td>
                      <td>{formatDate1(item.created_date)}</td>
                      <td>{item.date_of_payment ? formatDate1(item.date_of_payment) : "N/A"}</td>
                      <td style={{ fontWeight: "bold" }} >{item.transaction_type_name}</td>
                      <td>{item.payment_mode}</td>
                      <td>
                        ₹{" "}
                        {item.UpdatedAmount !== null
                          ? item.UpdatedAmount
                          : item.amount}
                      </td>
                      
                      <td
                        style={{
                          color: item.is_verified === 0 ? "#FFA500" : "#20BF44",
                        }}
                      >
                        {item.is_verified === 0 ? "Requested" : "Verified"}
                      </td>
                      <td>{item.approved_by}</td>                      
                      <td>{item.remark_Doc}</td>
                      <td>{item.UTR_Number}</td>
                      <td>{item.Name}</td>
                      <td>{item.assigned_coordinator}</td>
                      <td style={{ display: "flex" }}>
                        <a
                          style={{
                            color: "#6a6a6a",
                            textDecoration: "none",
                            cursor: "pointer",
                            fontWeight: "bold",
                            pointerEvents: item.doc_name ? "auto" : "none",
                            opacity: item.doc_name ? 1 : 0.5,
                          }}
                          target="_blank"
                          href={
                            item.doc_name
                              ? `${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`
                              : "#"
                          }
                          rel="noopener noreferrer"
                        >
                          <img src={Forward} alt="Forward" />
                        </a>
                        <img
                          style={{
                            paddingLeft: "4px",
                            pointerEvents:
                              item.is_verified === 0 ? "none" : "auto",
                            opacity: item.is_verified === 0 ? 0.5 : 1,
                            cursor:
                              item.is_verified === 0
                                ? "not-allowed"
                                : "pointer",
                          }}
                          src={showDoc}
                          alt="showDoc"
                          onClick={() => {
                            if (item.is_verified !== 0) {
                              nextPage1(item.payment_receipt_id);
                            }
                          }}
                        />
                        <img
                          style={{ cursor: "pointer" }}
                          src={search}
                          onClick={() =>
                            toggleSearchDiv(item.payment_receipt_id)
                          }
                          alt="search"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <p>empty</p>
                )}
              </tbody>
            )}
          </table>
        </div>
      </div>

      <nav
        aria-label="Page navigation"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "1rem",
        }}
      >
        <ul className="pagination">
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ color: "#6A6A6A" }}
            >
              Previous
            </a>
          </li>
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ color: "#5B489D" }}
            >
              {currentPage - 1}
            </a>
          </li>
          <li className="page-item active">
            <a className="page-link" style={{ backgroundColor: "#5B489D" }}>
              {currentPage}
            </a>
          </li>
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={endIndex >= paymentReceiptResponse?.length}
              style={{ color: "#5B489D" }}
            >
              {currentPage + 1}
            </a>
          </li>
          <li className="page-item">
            <a
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={endIndex >= paymentReceiptResponse?.length}
              style={{ color: "#5B489D" }}
            >
              Next
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default PaymentList;
